<template>
  <app-layout>
    <page-header> Adauga masina </page-header>

    <page-section>
      <vendor-cars-create-form :rfq-id="id" @created:car="redirect()" />
    </page-section>
  </app-layout>
</template>

<script>
import PageHeader from "../components/PageHeader.vue";
import PageSection from "../components/PageSection.vue";
import VendorCarsCreateForm from "../components/VendorCarsCreateForm.vue";
import AppLayout from "../layout/AppLayout.vue";

export default {
  components: {
    AppLayout,
    VendorCarsCreateForm,
    PageHeader,
    PageSection,
  },

  props: ["id"],

  methods: {
    redirect() {
      this.$router.push({ name: "cars.index" });
    },
  },
};
</script>

<style></style>
